// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface ChangeRequestTypeDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
	code: string | null;
	selectable: boolean;
	daysValid: number;
	cutoffWindow: number;
}

const ChangeRequestTypeDTO = {
    className: 'ChangeRequestTypeDTO',
    create: (initValues?: Partial<ChangeRequestTypeDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
			code: "",
			selectable: false,
			daysValid: 0,
			cutoffWindow: 0,
        },
        initValues);
    },
	id: 'id',
	name: 'name',
	code: 'code',
	selectable: 'selectable',
	daysValid: 'daysValid',
	cutoffWindow: 'cutoffWindow',
};

export default ChangeRequestTypeDTO;